import {
  Component,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { DIALOG_DATA } from '../../../../global.variable';
import { ToasterService } from '../../services/toaster.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { SubBillerService } from '../../../pages/pages/sub-biller/sub-biller.service';

@Component({
  selector: 'gtapp-select-sub-biller',
  standalone: false,
  templateUrl: './select-sub-biller.component.html',
  styleUrl: './select-sub-biller.component.scss',
})
export class SelectSubBillerComponent implements OnInit, OnDestroy {
  selectedSubBiller: any = {};
  selectedSubBillerBackup: any = {};

  subBillerListData: any = [];
  subBillerListDataBackup: any = [];

  subBillerStringValue: string = '';

  constructor(
    @Optional() protected dialogRef: DialogRef,
    private subBillerService: SubBillerService,
    @Optional() @Inject(DIALOG_DATA) public dialogueData: any,
    private toasterService: ToasterService,
  ) {}
  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.selectedSubBiller =
      this.dialogueData?.selectedSubBiller || this.selectedSubBiller;
    this.selectedSubBillerBackup = JSON.parse(
      JSON.stringify(this.selectedSubBiller),
    );
    this.onSubBillerLookup();
  }
  onCloseDialogue(val: any = false) {
    this.dialogRef.close(val);
  }
  onSelectSubBiller(subBillerData: any) {
    if (subBillerData?.id) {
      this.onCloseDialogue(subBillerData);
    }
    if (subBillerData?.key == 0) {
      if (!this.subBillerStringValue) {
        this.toasterService.setMessage({
          errorMessage: 'Sub Biller Name cannot be empty!!!',
        });
        return;
      }
      this.subBillerService
        .createSubBiller({ company_name: this.subBillerStringValue }, {})
        .then((resp: any) => {
          if (resp?.status != 'success') {
            this.toasterService.setMessage({ errorMessage: resp?.message });
            return;
          }
          this.onCloseDialogue(resp?.data);
        });
    }
  }
  editField() {
    this.shiftFocus('subBillerLookupFieldId');
    this.subBillerListData = JSON.parse(
      JSON.stringify(this.subBillerListDataBackup),
    );
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    });
  }
  onSubBillerLookup(event?: any) {
    const searchStr = event?.target?.value || '';
    const subBillerStringPresent = !!this.subBillerStringValue;
    this.subBillerStringValue = searchStr;

    if (subBillerStringPresent != !!this.subBillerStringValue) {
      this.subBillerListData = [...this.subBillerListData];
    }

    if (searchStr?.length > 3 || !searchStr) {
      let params: any = { search_str: searchStr };

      this.subBillerService.fetchSubBillerList(params).subscribe((res: any) => {
        this.subBillerListData = res?.data || [];
        if (!searchStr) this.subBillerListDataBackup = res?.data || [];
      });
    }
  }
}
